import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::store
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:12
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions'
*/
export const store = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/credit/{naturalPerson}/liability-positions',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::store
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:12
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions'
*/
store.url = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { naturalPerson: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { naturalPerson: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
    }

    return store.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::store
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:12
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions'
*/
store.post = (args: { naturalPerson: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::update
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:17
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions/{liabilityPosition}'
*/
export const update = (args: { naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/credit/{naturalPerson}/liability-positions/{liabilityPosition}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::update
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:17
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions/{liabilityPosition}'
*/
update.url = (args: { naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
            liabilityPosition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
        liabilityPosition: typeof args.liabilityPosition === 'object'
        ? args.liabilityPosition.id
        : args.liabilityPosition,
    }

    return update.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace('{liabilityPosition}', parsedArgs.liabilityPosition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::update
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:17
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions/{liabilityPosition}'
*/
update.put = (args: { naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::update
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:17
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions/{liabilityPosition}'
*/
update.patch = (args: { naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::destroy
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:22
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions/{liabilityPosition}'
*/
export const destroy = (args: { naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/credit/{naturalPerson}/liability-positions/{liabilityPosition}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::destroy
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:22
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions/{liabilityPosition}'
*/
destroy.url = (args: { naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            naturalPerson: args[0],
            liabilityPosition: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        naturalPerson: typeof args.naturalPerson === 'object'
        ? args.naturalPerson.id
        : args.naturalPerson,
        liabilityPosition: typeof args.liabilityPosition === 'object'
        ? args.liabilityPosition.id
        : args.liabilityPosition,
    }

    return destroy.definition.url
            .replace('{naturalPerson}', parsedArgs.naturalPerson.toString())
            .replace('{liabilityPosition}', parsedArgs.liabilityPosition.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\LiabilityPositionController::destroy
* @see app/Http/Controllers/Investors/LiabilityPositionController.php:22
* @route '//app.finesthub.de/credit/{naturalPerson}/liability-positions/{liabilityPosition}'
*/
destroy.delete = (args: { naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } } | [naturalPerson: string | number | { id: string | number }, liabilityPosition: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const LiabilityPositionController = { store, update, destroy }

export default LiabilityPositionController